import { AppContext } from '@/contexts/app.context';
import { useTraineesQuery } from '@/hooks/query-hooks';
import { isTrainerUser } from '@/utils/user';
import { Autocomplete, TextField } from '@mui/material';
import { useContext } from 'react';

export const TraineesAutocomplete = (props: { selectedTraineeId?: string; setSelectedTraineeId: (deckId?: string) => void }) => {
  const { selectedTraineeId, setSelectedTraineeId } = props;
  const { state } = useContext(AppContext);
  const { trainees } = useTraineesQuery(isTrainerUser(state?.userProfile) ?? false);
  const trainee = trainees?.find((t) => t.userId === selectedTraineeId);

  return trainees ? (
    <Autocomplete
      autoHighlight
      id="tags-outlined"
      defaultValue={trainee}
      onChange={(event, trainee) => {
        if (trainee) setSelectedTraineeId(trainee.userId);
        else setSelectedTraineeId(undefined);
      }}
      options={trainees ?? []}
      getOptionLabel={(option) => option.name}
      filterSelectedOptions
      sx={{ minWidth: 200, paddingTop: 1 }}
      renderInput={(params) => <TextField variant="outlined" {...params} label={`Trainees`} placeholder={selectedTraineeId ? `Select Trainee` : undefined} />}
    />
  ) : (
    <></>
  );
};
